// extracted by mini-css-extract-plugin
module.exports = {"DialogueBox":"DialogueBox_DialogueBox__UVXMb","DialogueBoxTextWrapper":"DialogueBox_DialogueBoxTextWrapper__2w_uL","DialogueBoxButtons":"DialogueBox_DialogueBoxButtons__1Hqwu"};